/**
 * 国际化配置文件
 * SC:中文
 * TC:繁体
 */
 export default {

    myFavorite: { SC:"我的最爱", TC: "我的最愛" , EN: "My Favorite" }
    ,settingsFavorite: { SC:"设置最爱", TC: "設定最愛" , EN: "Setup Favorite" }
    ,saveSuccess: { SC:"保存成功", TC: "保存成功", EN: "Saved successfully." }
    ,save: { SC:"保存", TC: "保存", EN: "Save" }
    ,dataBeSaving: { SC:"数据保存中...", TC: "數據保存中...", EN: "Data is processing..." }
    ,funcSelect: { SC:"模块选择", TC: "模塊選擇", EN: "Functions" }
    ,favorite: { SC:"最爱", TC: "最愛", EN: "Favorite" }
    ,bottom: { SC:"置底", TC: "置底", EN: "Bottom" }
    ,pinned: { SC:"置顶", TC: "置頂", EN: "Top" }
    ,sysManage: { SC:"系统管理", TC: "系統管理" , EN: "System" }
}